import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, IExtractedProps, ISirenAction } from "Common/utils/commonTypes";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";

export const PreventionBox: React.FC<IComponentProps> = props => {
    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["text", "title", "image", "color", "alt", "anchorId"]
    });
    const onButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, actions: ISirenAction[], label: string, title: string) => {

        //Tracking for matomo
        const buttonTitle = title.replace(/<\/?[^>]+(>|$)/g, "");
        const triggerMatomoEvent: ISirenAction = {
            actionType: "triggerMatomoEvent",
            properties: {
                category: "{%pageTitle%}",
                action: "Cliquer",
                name: `${buttonTitle} - BTN ${label}`
            }
        };
        e.preventDefault();
        webui.getUtils().dispatchSirenActions(
            props,
            ["default", "click", ],
            { actions: [triggerMatomoEvent, ...actions] }
        );
    };
    const getButtonProps = () => {
        const siren = EntityBuilder.of(props.data);
        const button = siren.getChild("button");
        if (!button.isEmpty()) {
            const buttonLabel = button.getLabel();
            const buttonActions = button.getActions();
            return {
                buttonLabel,
                buttonActions
            };
        }
        return null;
    };
    const buttonProps = getButtonProps();
    return (
        <div className="tq-flex-container" id={dataProps.anchorId ? dataProps.anchorId : null}>
            <div
                className={`un-left-border-box-${dataProps.color}
                tq-flex-item un-left-border-box un-left-border-box-wide`}
            >
                <img src={dataProps.image} alt={dataProps.alt} />
                <div className="tq-title">
                    <span
                        className="tq-text-node"
                        dangerouslySetInnerHTML={{
                            __html: xssFilter.process(dataProps.title)
                        }}
                        data-hyperlinks-container={true}
                    />
                </div>
                <div
                    className="un-left-border-box-content"
                    dangerouslySetInnerHTML={{
                        __html: xssFilter.process(dataProps.text)
                    }}
                    data-hyperlinks-container={true}
                ></div>
                <div
                    className="un-left-border-box-content"
                    >
                    {buttonProps && (
                        <button
                            className="un-anchor-custom tq-button un-button-solid"
                            onClick={(e) => onButtonClick(e, buttonProps?.buttonActions, buttonProps?.buttonLabel, dataProps.title)}
                        >
                            <span className="tq-text-node">{buttonProps?.buttonLabel}</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default webui.connectComponent()(PreventionBox);
